import axiosInstance from 'axios';

// Create axios instance with custom config
const axios = axiosInstance.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include auth token in every request (except auth paths)
axios.interceptors.request.use(
  config => {
    const token = process.env.VUE_APP_AUTH_TOKEN;

    if (token && !config.url?.includes('/auth')) {
      config.headers['x-auth-token'] = token;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios;
